import useQuery from "../../common/utilities/hooks/useQuery";
import { useEffect } from "react";
import useAuth from "../../authProvider/hooks/useAuth";

const useInvitation = () => {
  const { loginWithInvite } = useAuth();

  const searchParams = useQuery();
  const invitation = searchParams.get("invitation");
  const organization = searchParams.get("organization");

  useEffect(() => {
    if (!invitation || !organization) {
      return;
    }

    loginWithInvite(invitation, organization);
  }, [invitation, organization, loginWithInvite]);
};

export default useInvitation;
